import { GridColDef } from '@mui/x-data-grid';
import { Button, Chip, Stack, Typography } from '@mui/material';
import { format } from 'date-fns-tz';
import { ArrowForward } from '@mui/icons-material';
import { SizeLabel } from './size-label.tsx';
import { VehicleLabel } from './vehicle-label.tsx';
import { AlgorithmLabel } from './algorithm-label.tsx';

function formatDate(parsedDate: Date) {
  return format(parsedDate, 'HH:mm:ss');
}

function formatTextDate(parsedDate: Date) {
  return format(parsedDate, 'yyyy/M/dd');
}

const StatusRender = (props: { status: string }) => {
  switch (props.status) {
    case 'accepted':
      return (
        <Chip
          component={'span'}
          size="small"
          variant="outlined"
          label={'Aceptado'}
          color="primary"
        />
      );
    case 'rejected':
      return (
        <Chip
          component={'span'}
          size="small"
          variant="outlined"
          label={'Rechazado'}
          color="error"
        />
      );
    default:
      return (
        <Chip
          component={'span'}
          size="small"
          variant="outlined"
          label={'Pendiente'}
          color="warning"
        />
      );
  }
};

const columns: GridColDef[] = [
  {
    field: 'id',
    flex: 1,
    headerName: '',
    align: 'left',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Stack alignItems="center" direction="row" spacing={2}>
        <Stack alignItems="center">
          <AlgorithmLabel algorithm={params.row.algorithm} />
          <span>[{params.row.prefix.toUpperCase()} ]</span>
        </Stack>
        <Stack direction="column">
          <Typography variant="h6" fontWeight="bold" color="black">
            {params.row.plan_name}
          </Typography>
          <Stack>
            <Typography variant="body2" fontWeight="bold" color="secondary">
              <Typography
                component={'span'}
                color="primary"
                display="inline"
                fontWeight={'bold'}
              ></Typography>
            </Typography>
            <Typography variant="caption" color="secondary">
              {params.row.created_by
                .split(' | ')
                .map((txt: string, i: number) => (
                  <div key={`el-${i}`}>{txt}</div>
                ))}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    ),
  },
  {
    width: 96,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    field: 'total_routes',
    headerName: 'Rutas',
    renderCell: (params) => (
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <Typography
          display="block"
          variant="h4"
          fontWeight="lighter"
          color="primary"
        >
          {params.row.total_routes}
        </Typography>
      </Stack>
    ),
  },
  {
    width: 128,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    field: 'total_orders',
    headerName: 'Paquetes',
    renderCell: (params) => (
      <Stack direction="column" alignItems="center">
        <Typography
          display="block"
          variant="h4"
          fontWeight="lighter"
          color="secondary"
        >
          {params.row.total_orders}
        </Typography>
        <StatusRender status={params.row.induct_accept} />
      </Stack>
    ),
  },
  {
    width: 160,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    field: 'sizes',
    headerName: 'Tamaños',
    renderCell: (params) => (
      <div className="flex items-center justify-center h-full">
        <SizeLabel sizes={params.row.sizes} />
      </div>
    ),
  },
  {
    width: 196,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    field: 'vehicles_used',
    headerName: 'Vehículos',
    renderCell: (params) => (
      <div className="flex items-center justify-center h-full">
        <VehicleLabel vehicles={params.row.vehicles_used} />
      </div>
    ),
  },
  {
    width: 96,
    sortable: false,
    align: 'center',
    field: 'updated_at',
    headerAlign: 'center',
    headerName: 'Creado',
    renderCell: (params) => {
      return (
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <Typography variant="body2" fontWeight="bold">
            {formatTextDate(new Date(params.row.created_at))}
          </Typography>
          <Typography
            sx={{ display: 'inline' }}
            variant="caption"
            fontWeight="bold"
            color="secondary"
          >
            {formatDate(new Date(params.row.created_at))}
          </Typography>
        </Stack>
      );
    },
  },
  {
    width: 64,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    field: 'action',
    headerName: '',
    renderCell: (params) => (
      <div className="flex items-center justify-center h-full">
        <Button
          href={`/simulation/${params.row.plan_id}`}
          size="small"
          color="secondary"
          endIcon={<ArrowForward />}
          disabled={
            params.row.induct_accept !== 'accepted' &&
            params.row.induct_accept !== 'pending'
          }
        >
          Ver
        </Button>
      </div>
    ),
  },
];
export default columns;
